<template>
  <div :class="[isFixed ? 'fixed-loader' : 'normal-loader']" class="app-loader" v-if="isLoading">
    <v-progress-circular :size="size" :width="width" :color="color" :indeterminate="indeterminate" />
  </div>
</template>

<script>
export default {
  name: "AppLoader",

  data: () => ({
    loader: true,
  }),

  props: {
    size: {
      default: 70,
      type: Number,
    },

    width: {
      default: 7,
      type: Number,
    },

    color: {
      default: "primary",
      type: String,
    },

    indeterminate: {
      default: true,
      type: Boolean,
    },

    isLoading: {
      default: true,
      type: Boolean,
    },

    isFixed: {
      default: false,
      type: Boolean,
    },
  },

  mounted() {
    // $eventHub.$on(EventConstraints.SHOW_APP_LOADER, this.start);
    // $eventHub.$on(EventConstraints.HIDE_APP_LOADER, this.stop);
  },

  methods: {
    /**
     * Start app loading
     * @return {void}
     */
    start() {
      this.loader = true;
    },

    /**
     * Stop app loading
     * @return {void}
     */
    stop(timeout = 500) {
      setTimeout(() => {
        this.loader = false;
      }, timeout);
    },
  },
};
</script>
<style>
.fixed-loader {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 10;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fffe;
}
.normal-loader {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 10rem;
}
</style>
